<template>
  <div class="OrderSummary-root">
    <info-box :show-line="false" bordered title="订单概况" :column="3">
      <template v-if="orderDetail" slot="mainContent">
        <a-descriptions-item label="订单状态">
          <span class="status-txt">{{ orderStatus }}</span>
          <span v-track-click="{ trackName: '仓配-查看明细' }" class="viewDetails" @click="checkLogs">查看明细</span>
        </a-descriptions-item>
        <a-descriptions-item label="仓库">
          {{ filterWarehouse() }}
        </a-descriptions-item>
        <a-descriptions-item label="订单号">
          {{ orderSummary.unifyOdrNo }}
        </a-descriptions-item>
        <!-- <a-descriptions-item v-if="sensitiveFields.includes('use_car_ask')" label="用车要求">
          {{ orderSummary.orderTypeTxt }}
        </a-descriptions-item> -->
        <a-descriptions-item label="外部订单号">
          {{ orderSummary.crmNumber }}
        </a-descriptions-item>
        <a-descriptions-item label="订单来源">
          {{ orderSummary.odrChannel }}
        </a-descriptions-item>
        <a-descriptions-item label="下单时间">
          {{ orderSummary.orderTime }}
        </a-descriptions-item>
        <a-descriptions-item label="是否运输">
          {{ orderSummary.needTransport }}
        </a-descriptions-item>
        <a-descriptions-item v-if="filterShow()" label="调出货主">
          {{ orderSummary.deliverCustomerName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="filterShow()" label="调入货主">
          {{ orderSummary.storeCustomerName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="!filterShow()" label="仓货主">
          <template v-if="orderSummary.ext && orderSummary.ext.demoData">
            **餐饮连锁
          </template>
          <template v-else>
            {{ orderSummary.storeCustomerName || orderSummary.deliverCustomerName || '' }}
          </template>
        </a-descriptions-item>
        <a-descriptions-item label="下单货主">
          {{ orderSummary.tenantName }}
        </a-descriptions-item>
        <a-descriptions-item label="下单人">
          {{ orderSummary.createUserName }}
        </a-descriptions-item>
        <a-descriptions-item :label="orderSummary.deliveryTypeCode ? '出库类型' : '入库类型'">
          {{
            orderSummary.deliveryTypeCode
            ? OUTTYPELIST[orderSummary.deliveryTypeCode]
            : INTYPELIST[orderSummary.storeTypeCode]
          }}
        </a-descriptions-item>
        <a-descriptions-item :label="getTimeTile">
          {{ orderSummary.planTime | formatTimestamp }}
        </a-descriptions-item>
        <!-- <a-descriptions-item label="仓操作项">
          <span v-for="(item, index) in orderSummary.operateOptions" :key="item">
            {{ index + 1 }}.{{ item }}
          </span>
        </a-descriptions-item> -->
        <a-descriptions-item v-if="sensitiveFields.includes('project')" label="运营项目">
          {{ orderSummary.projectName }}
        </a-descriptions-item>
        <!-- <a-descriptions-item v-if="sensitiveFields.includes('payment_method')" label="付款方式">
          {{ orderSummary.settlementMethod }}
        </a-descriptions-item> -->
        <a-descriptions-item v-if="sensitiveFields.includes('project_leader')" label="项目负责人信息">
          <a-tooltip>
            <template #title>
              <p v-for="(item, index) in orderSummary.mainUser" :key="index">
                {{ item }}
              </p>
            </template>
            <div class="ellipsis main-user">
              {{ orderSummary.mainUser.join(',') }}
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item v-if="sensitiveFields.includes('providers')" label="服务商">
          {{ orderSummary.carrierTenantName }}
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          {{ orderSummary.remark }}
        </a-descriptions-item>
      </template>
    </info-box>
    <status-modal ref="statusModal" />
  </div>
</template>

<script>
import moment from 'moment';
import InfoBox from './InfoBox.vue';
import {
  OdrChannelMap,
  SCENE,
  STATUSTEXT,
  ORDERSTATUS as statusEnu,
} from '../../warehouseList/constant.js';
import { INTYPELIST, OUTTYPELIST } from '../../warehouseCreate/constant.js';
import StatusModal from '../../../orderManage/components/StatusModal.vue';

export default {
  name: 'OrderSummary',
  components: {
    InfoBox,
    StatusModal,
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => null,
    },
    sensitiveFields: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      INTYPELIST,
      OUTTYPELIST,
      STATUSTEXT,
      statusEnu,
      SCENE,
    };
  },
  computed: {
    getTimeTile () {
      const { scene } = this.orderDetail;
      if (scene === this.SCENE.STORE_ONLY || scene === this.SCENE.STORE_TRANSPORT) {
        return '计划到仓时间';
      }
      if (scene === this.SCENE.DELIVER_ONLY || scene === this.SCENE.DELIVER_TRANSPORT) {
        return '交货时间';
      }
      return '调拨时间';
    },
    orderStatus () {
      const { status } = this.orderDetail;
      return STATUSTEXT[status];
    },
    orderSummary () {
      const { orderDetail } = this;
      const { operateOptions = '' } = orderDetail.ext || {};
      const mainUser = [];
      const { unifyProjectGroups = [] } = orderDetail;
      unifyProjectGroups.forEach((item) => {
        mainUser.push(`${item.userName}${item.userPhone ? `(${item.userPhone})` : ''}`);
      });
      return {
        ...orderDetail,
        crmNumber: orderDetail.crmNumber || '--',
        orderTime: moment(orderDetail.createTime).format('YYYY-MM-DD HH:mm:ss'),
        odrChannel: OdrChannelMap[orderDetail.odrChannel$],
        needTransport: orderDetail.scene?.includes('TRANSPORT') ? '是' : '否',
        carrierTenantName: orderDetail.ext?.demoData
          ? '运荔枝演示'
          : orderDetail.carrierTenantName,
        tenantName: orderDetail.ext?.demoData ? '**餐饮连锁' : orderDetail.tenantName,
        operateOptions: (operateOptions && operateOptions.split(',')) || [],
        mainUser,
      };
    },
  },
  created () { },
  mounted () { },
  methods: {
    async checkLogs () {
      const { unifyOdrNo } = this.orderDetail;
      this.$refs.statusModal.show(
        unifyOdrNo,
        true,
        this.orderDetail.isWarehouseMultiDischargeOrder || false
      );
    },
    filterShow () {
      return this.orderSummary.scene === SCENE.DELIVER_TRANSPORT_STORE;
    },
    filterWarehouse () {
      const { scene } = this.orderSummary;
      if (this.orderSummary.ext?.demoData) {
        return '运荔枝演示仓库';
      }
      if (scene === SCENE.DELIVER_TRANSPORT_STORE || scene === SCENE.DELIVER_STORE) {
        return `${this.orderSummary.deliverWarehouseName} -> ${this.orderSummary.storeWarehouseName}`;
      }
      if (scene === SCENE.STORE_TRANSPORT || scene === SCENE.STORE_ONLY) {
        return this.orderSummary.storeWarehouseName;
      }
      if (scene === SCENE.DELIVER_ONLY || scene === SCENE.DELIVER_TRANSPORT) {
        return this.orderSummary.deliverWarehouseName;
      }
      return '';
    },
  },
};
</script>

<style lang="less" scoped>
// /deep/ .ant-descriptions-item-content{
//     width: 60%;
// }
.OrderSummary-root {
  background-color: #fff;
  border-radius: 6px;

  .status-txt {
    color: #171717;
    font-size: 16px;
    font-weight: 500;
  }

  .viewDetails {
    font-size: 12px;
    line-height: 24px;
    color: #171717;
    margin-left: 8px;
    color: #06b880;
    cursor: pointer;
  }
}

.main-user {
  max-width: 240px;
}
</style>
